define('cart/cartItem',[
    "shoppingCartIcon/shoppingCartIcon",
    "shoppingCartIcon/miniCart",
    "orderSummary/orderSummary",
    "common/alertMessage",
    "common/spinner",
    "common/formUtils",
    "quantitySelector/quantitySelector"
],
    function (shoppingCartIcon, miniCart, orderSummary, alertMessage, spinner, formUtils, quantitySelector) {

        const quantityInputSelector = ".quantity-selector input";

        function initEventHandlers() {
            $(".cart-item " + quantityInputSelector).off("quantityChanged").on("quantityChanged", updateQuantity);
            $(".cart-item .btn.remove-item").off("click").on("click", removeItem);
            $(".cart-item button.add-to-cart").off("click").on("click", addToCartClicked);
            $(".cart-item .btn.edit-item").off("click").on("click", editItemInQuickEditModal);
        }

        function cartItemElement(childElement) {
            return $(childElement).closest(".cart-item");
        }

        function cartItemWrapperSelector(childElement, orderLineId) {
            var lineElement;
            if (orderLineId) {
                lineElement = $(childElement).closest(".cart-items").find(".cart-item[data-order-line-id='" + orderLineId + "']");
            } else {
                lineElement = cartItemElement(childElement);
            }
            var wrapperElement = $(lineElement).closest(".cart-item-wrapper");
            if (wrapperElement.length) return "#" + wrapperElement[0].id;
            return "#unknown";
        }

        function getDisplayMode(childElement) {
            var cartItemWrapper = cartItemWrapperSelector(childElement);
            if (cartItemWrapper !== "#unknown") {
                return $(cartItemWrapper).data("displayMode");
            }
            return null;
        }

        function apiEndpoint(displayMode) {
            switch (displayMode) {
                case "Cart":
                    return "Order/UpdateCart";
                case "MyLists":
                case "SharedList":
                    return "Wishlist/UpdateWishlistItem";
                default:
                    return null;
            }
        }

        function orderLineId(childElement) {
            var cartItem = cartItemElement(childElement);
            if (cartItem) {
                return $(cartItem).data("order-line-id");
            }
            return null;
        }

        function getWishlistId(childElement) {
            var wishlistElement = $(childElement).closest(".wishlist");
            if (wishlistElement) {
                return $(wishlistElement).data("itemId");
            }
            return null;
        }

        function getQuantity(childElement) {
            var cartItem = cartItemElement(childElement);
            if (cartItem) {
                return $(cartItem).find(quantityInputSelector).val();
            }
            return null;
        }

        function getVariantSkus(childElement) {
            var cartItem = cartItemElement(childElement);
            if (cartItem) {
                return {
                    productSku: $(cartItem).data("productSku"),
                    variantSku: $(cartItem).data("variantSku")
                };
            }
            return { productSku: null, variantSku: null };
        }

        function setQuantity(childElement, quantity) {
            var cartItem = cartItemElement(childElement);
            if (cartItem) {
                var inputItem = $(cartItem).find(quantityInputSelector);
                if (inputItem) {
                    $(inputItem).val(quantity);
                    $(inputItem).trigger("quantityChanged");
                }
            }
        }

        function updateQuantity(event) {
            var quantity = $(this).val();
            quantitySelector.validateQuantity(this);
            totalPriceSpinner("show", this);
            sendUpdateCartRequest({ Quantity: quantity }, this);
        }

        function removeItem(event) {
            spinner.show(cartItemWrapperSelector(this) + " .spinner-wrapper");
            sendUpdateCartRequest({ Quantity: 0 }, this);
        }

        function editItemInQuickEditModal(event) {
            cartItemBeingEditedInQuickEditModal = cartItemElement(this);
        }

        var cartItemBeingEditedInQuickEditModal;

        function updateCartFromQuickEditModal(updateData) {
            if (updateData.oldVariantGuid != updateData.newVariantGuid)
            {
                // variant was changed
                spinner.show(cartItemWrapperSelector(cartItemBeingEditedInQuickEditModal) + " .spinner-wrapper");
                sendUpdateCartRequest({
                    Quantity: updateData.newQuantity,
                    OldVariantGuid: updateData.oldVariantGuid,
                    NewVariantGuid: updateData.newVariantGuid,
                    NewProductSku: updateData.newProductSku,
                    NewVariantSku: updateData.newVariantSku
                }, cartItemBeingEditedInQuickEditModal);
            }
            else if (updateData.oldQuantity != updateData.newQuantity) {
                // only the quantity was changed
                setQuantity(cartItemBeingEditedInQuickEditModal, updateData.newQuantity);
            }
        }

        function sendUpdateCartRequest(postData, clickedElement) {
            postData.OrderLineId = orderLineId(clickedElement);
            //if (!postData.OldVariantGuid) postData.OldVariantGuId = "0";
            //if (!postData.NewVariantGuid) postData.NewVariantGuId = "0";
            formUtils.useToken(postData);

            postData.DisplayMode = getDisplayMode(clickedElement);
            if (postData.DisplayMode === "MyLists" || postData.DisplayMode === "SharedList") {
                postData.WishlistId = getWishlistId(clickedElement);
            }

            var wrapperSelector1;   // for the line that needs to be removed or replaced
            var wrapperSelector2;   // for the other line that needs to be refreshed

            $.ajax({
                type: "POST",
                url: "/customapi/" + apiEndpoint(postData.DisplayMode),
                dataType: "json",
                data: postData,
                success: function (data) {
                    if (data.status === "OK" && data.action !== "NONE") {
                        if (data.action === "JUST UPDATE TOTALS") {
                            setPriceTotal(clickedElement, data.lineTotal);
                        }
                        if (data.action === "REMOVE") {
                            wrapperSelector1 = cartItemWrapperSelector(clickedElement, data.removeLineId);
                            wrapperSelector2 = cartItemWrapperSelector(clickedElement, data.refreshLineId);
                            removeLine(wrapperSelector1);
                            spinner.show(wrapperSelector2 + " .spinner-wrapper");
                            replaceLine(wrapperSelector2, data.content);
                            spinner.hide(wrapperSelector2 + " .spinner-wrapper");
                        }
                        if (data.action === "REPLACE") {
                            wrapperSelector1 = cartItemWrapperSelector(clickedElement, data.removeLineId);
                            replaceLine(wrapperSelector1, data.content);
                        }
                        if (postData.DisplayMode === "Cart") {
                            // cart
                            shoppingCartIcon.updateItemCount(data.cartItemsCount);
                            orderSummary.refreshSummaryValues();
                            //gtmHelper.processCartChanges(data.changedCartItems);     Google Tag Manager is not used
                        } else {
                            // wishlists
                            refreshWishlistTotals(wrapperSelector2 || wrapperSelector1 || clickedElement, data.cartItemsCount, data.cartSubtotal);
                        }
                    } else if (data.status === "ERROR") {
                        alertMessage.error(data.message);
                        setPriceTotal(clickedElement, "error");
                    }
                },
                error: function (jq, status, errorThrown) {
                    alertMessage.error(status + ": " + errorThrown);
                    setPriceTotal(clickedElement, "error");
                },
                complete: function () {
                    totalPriceSpinner("hide", clickedElement);
                    spinner.hide(wrapperSelector1 + " .spinner-wrapper");
                }

            });
        }

        function removeLine(wrapperSelector) {
            $(wrapperSelector + " .cart-item-placeholder").remove();
        }

        function replaceLine(wrapperSelector, content) {
            if (content) {
                $(wrapperSelector + " .cart-item-placeholder").html(content);
                initEventHandlers();
                quantitySelector.init();
            }
        }

        function setPriceTotal(clickedElement, value) {
            var cartItem = cartItemElement(clickedElement);
            var priceTotalElement = cartItem.find(".price-total");
            priceTotalElement.html(value);
        }

        function totalPriceSpinner(what, clickedElement) {
            var cartItem = cartItemElement(clickedElement);
            var priceTotalElement = cartItem.find(".price-total");
            var spinnerElement = cartItem.find(".spinner");
            if (what === "show") {
                priceTotalElement.addClass("d-none");
                spinnerElement.removeClass("d-none");
            }
            else if (what === "hide") {
                spinnerElement.addClass("d-none");
                priceTotalElement.removeClass("d-none");
            }
        }

        function refreshWishlistTotals(clickedElement, itemCount, subtotal) {
            var totalsElement = $(clickedElement).closest(".wishlist").find(".totals");
            var totalsSpinnerSelector = "#" + $(totalsElement).find(".spinner-wrapper")[0].id;
            spinner.show(totalsSpinnerSelector);
            $(totalsElement).find(".item-count-value").text(itemCount);
            $(totalsElement).find(".subtotal-value").html(subtotal);
            spinner.hide(totalsSpinnerSelector);
        }

        var itemsWithoutPrice = [];
        function checkIfItemHasPrice(childElement) {
            var cartItem = cartItemElement(childElement);
            if (cartItem) {
                if ($(cartItem).find(".item-price-value").text()) return;  // it's okay, it has a price
                // no price, put the item into the array of bad items
                itemsWithoutPrice.push($(cartItem).find(".item-name").text());
            }
        }

        function addToCartClicked(event) {
            itemsWithoutPrice = [];
            var spinnerSelector = "#" + $(this).closest(".add-to-cart-wrapper").find(" .spinner-wrapper")[0].id;
            var quantity = getQuantity(this);
            if (quantity != 0) {
                checkIfItemHasPrice(this);
                if (itemsWithoutPrice.length) {
                    alertMessage.error(CP.Messages["Add To Cart/No Price For Product"], null, false);
                }
                else {
                    var skus = getVariantSkus(this);
                    addToCart(
                        [{
                            ProductSku: skus.productSku,
                            VariantSku: skus.variantSku,
                            Quantity: quantity
                        }],
                        spinnerSelector
                    );
                }
            }
        }


        function addAllToCart(listSelector, spinnerSelector) {
            itemsWithoutPrice = [];
            var addToCartButtons = $(listSelector + " .cart-item button.add-to-cart");
            if (addToCartButtons.length) {
                var itemList = [];
                addToCartButtons.each(function (index, element) {
                    var quantity = getQuantity(element);
                    if (quantity != 0) {
                        checkIfItemHasPrice(element);
                        var skus = getVariantSkus(element);
                        itemList.push({
                            ProductSku: skus.productSku,
                            VariantSku: skus.variantSku,
                            Quantity: quantity
                        });
                    }
                });

                if (itemsWithoutPrice.length) {
                    alertMessage.error(CP.Messages["Add To Cart/No Price For Product Plural"] + itemsWithoutPrice.join(", "), null, false);
                }
                else {
                    addToCart(
                        itemList,
                        spinnerSelector
                    );
                }
            }
            
        }

        function addToCart(itemList, spinnerSelector) {
            if (itemList.length === 0) return;

            var postData = {
                itemList: itemList
            };
            formUtils.useToken(postData);

            spinner.show(spinnerSelector);

            $.ajax({
                type: "POST",
                url: "/customapi/Order/AddToCart",
                dataType: "json",
                data: postData,
                success: function (data) {
                    if (data.status === "OK") {
                        shoppingCartIcon.updateItemCount(data.cartItems);
                        miniCart.flash();
                        //gtmHelper.processCartChanges(data.changedCartItems);     Google Tag Manager is not used
                    } else if (data.status === "ERROR") {
                        alertMessage.error(data.message);
                    }
                },
                error: function (jq, status, errorThrown) {
                    alertMessage.error(status + ": " + errorThrown);
                },
                complete: function () {
                    spinner.hide(spinnerSelector);
                }

            });

        }


        return {
            initEventHandlers: initEventHandlers,
            getQuantity: getQuantity,
            updateCartFromQuickEditModal: updateCartFromQuickEditModal,
            addAllToCart: addAllToCart
        };
    });

